class ComponentNavigationDropdown extends Theme.Component {

  connectedCallback() {
    this.addEvent("click", this.elements.link, (event) => {
      event.preventDefault();
      this.toggle();
    });

    document.addEventListener("click", (event) => {
      if (!this.contains(event.target)) {
        this.hideAll();
      }
    });
  }

  toggle() {
    const active = this.classList.contains("active--true");

    this.hideAll();

    if (!active) {
      this.show();
    }
  }

  show() {
    this.classList.add("active--true");
  }

  hide() {
    this.classList.remove("active--true");
  }

  hideAll() {
    document.querySelectorAll("component-navigation-dropdown").forEach((component) => {
      component.hide();
    });
  }
}

customElements.define("component-navigation-dropdown", ComponentNavigationDropdown);